import clip from "@/util/clipboard";

/**
 * 格式化日期 - 将年月日格式化为 YYYY-MM-DD 格式
 * @param {number} year - 年份
 * @param {number} month - 月份
 * @param {number} date - 日期
 * @returns {string} - 格式化后的日期字符串
 */
export function formatDate(year, month, date) {
  return [year, month, date].map(formatNumber).join('-');
}

/**
 * 数字格式化 - 给单位数字前加0
 * @param {number|string} n - 需要格式化的数字
 * @returns {string} - 格式化后的字符串
 */
export function formatNumber(n) {
  n = n.toString();
  return n[1] ? n : '0' + n;
}

/**
 * 复制内容到剪贴板
 * @param {string} text - 要复制的文本
 * @param {Event} event - 事件对象
 */
export function handleCopy(text, event) {
  clip(text, event);
}

/**
 * Tab页面移除处理
 * @param {string} targetName - 要移除的tab路径
 * @param {Object} context - Vue组件实例上下文
 */
export function tabRemove(targetName, context) {
  // 首页不可删除
  if(targetName == '/') {
    return;
  }
  //将该tab从options里移除
  context.$store.commit('delete_tabs', targetName);
  ////还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
  if (context.activeIndex === targetName) {
    // 设置当前激活的路由
    if (context.options && context.options.length >= 1) {
      context.$store.commit('set_active_index', context.options[context.options.length-1].route);
      context.$router.push({path: context.activeIndex});
    } else {
      context.$router.push({path: '/welcome'});
    }
  }
}

/**
 * 分页大小变化处理
 * @param {number} val - 新的页面大小
 * @param {Object} context - Vue组件实例上下文
 * @param {Function} callback - 回调函数
 */
export function handleSizeChange(val, context, callback) {
  context.pages.pageSize = val;
  if (typeof callback === 'function') {
    callback();
  }
}

/**
 * 当前页码变化处理
 * @param {number} page - 新的页码
 * @param {Object} context - Vue组件实例上下文
 * @param {Function} callback - 回调函数
 */
export function handleCurrentChange(page, context, callback) {
  context.pages.startRow = page;
  if (typeof callback === 'function') {
    callback();
  }
}

/**
 * 表单数据重置
 * @param {Object} context - Vue组件实例上下文
 */
export function resetFormData(context) {
  context.orderInfoForm = {};
  context.provinceId = null;
  context.cityId = null;
  context.areaId = null;
  context.streetId = null;
  context.shopId = "";
  context.provinceList = [];
  context.cityList = [];
  context.areaList = [];
  context.streetList = [];
  context.faultTypeList = [];
  context.faultSubclassList = [];
  context.faultTypeCheckList = [];
  context.faultSubCheckList = [];
  context.choosedSubclassList = [];
  context.onlyThreeData = false;
}

/**
 * 手机号验证函数
 * @param {string} phone - 手机号
 * @returns {boolean} - 是否有效
 */
export function validatePhone(phone) {
  if (!phone) {
    return false;
  }
  return /^1[3456789]\d{9}$/.test(phone);
}

/**
 * 验证规则 - 手机号码验证
 * @param {Object} rule - 验证规则
 * @param {string} value - 输入值
 * @param {Function} callback - 回调函数
 */
export function validateNumber(rule, value, callback) {
  if(!value){
    callback(new Error("请输入手机号码"));
  } else if (!validatePhone(value)) {
    callback(new Error("手机号码格式不正确"));
  } else {
    callback();
  }
}

/**
 * 正整数验证
 * @param {number|string} num - 要验证的数字
 * @returns {boolean} - 是否为正整数
 */
export function isPositiveInteger(num) {
  return /^[0-9]*[1-9][0-9]*$/.test(num);
}



// WEBPACK FOOTER //
// ./src/views/workOrder/newWorkOrderUtils/index.js